import { validate } from './validate.js';

validate('.js-validate-form');
